import FinalistOneCard from "@app/components/FinalisteOneCard";
import FinalistTwoCard from "@app/components/FinalisteTwoCard";
import FirstWinner from "@app/components/FirstWinner";
import Head from "@app/components/Head";
import { GetStaticPropsContext, GetStaticPropsResult } from "next";
import {
  getSubmissionStatus,
  SubmissionStatus,
} from "src/helpers/submissionStatus";
import data from "../../json/data.json";

type DataType = typeof data;
type Years = keyof DataType;

interface WinnerPageProps {
  data: DataType[Years];
  year: Years;
  submissionStatus: SubmissionStatus;
}

export default function WinnersPage(props: WinnerPageProps) {
  const { data, year } = props;

  return (
    <>
      <Head options={{ title: `Lauréats ${year}` }} />

      <section className="">
        <div className="container">
          <FirstWinner data={data} />
          <div className="w-full mx-auto md:w-4/5 md:flex items-center justify-around">
            <FinalistOneCard finalistOne={data.finalistOne} />
            <FinalistTwoCard finalistTwo={data.finalistTwo} />
          </div>
        </div>
      </section>
    </>
  );
}

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<WinnerPageProps>> {
  const slug = (context.params?.slug as string) || "";

  // Data fetching
  try {
    const year = slug.replace("annee-", "") as Years;
    const yearData = data[year] as DataType[Years];

    if (!yearData) throw new Error(`No post found with slug: ${slug}`);

    return {
      props: {
        data: yearData,
        year,
        submissionStatus: await getSubmissionStatus(),
      },
      // Every 30 minutes
      revalidate: 60 * 30,
    };
  } catch (error) {
    return {
      notFound: true,
      // Every 30 minutes
      revalidate: 60 * 30,
    };
  }
}

export async function getStaticPaths() {
  const years = Object.keys(data) as Years[];
  // Get the paths we want to pre-render based on posts
  const paths = years.map((year) => {
    const slug = `annee-${year}`;
    return { params: { slug } };
  });

  return { paths, fallback: "blocking" };
}
